import Alert from "./Alert.jsx";
import Snackbar from "./Snackbar";

export default {
  Alert,
  Snackbar,
};
